module.exports = __webpack_public_path__ + "static/dmon-019-44b6c8af26067e035abce58f1997aab9.jpg";